import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { TableRow, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import Table from 'components/tables';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableCell from 'components/tables/tableCell';
import { getTimelines } from 'redux/actions/timelineActions';
import moment from 'moment';
import { FULLDATE_FORMAT_SLASHES } from 'constants/config';
import Pagination from 'components/pagination/Pagination';


const CampaignTab = ({
  classes,
  timelines,
  openCampaign,
  ...props
}) => (
  <>
    <Table className={classes.table}>
      <TableHead>
        <TableCell>Campaign</TableCell>
        <TableCell>First day of sending</TableCell>
        <TableCell>Last day of sending</TableCell>
      </TableHead>
      <TableBody>
        {timelines.results.map(campaign => (
          <TableRow>
            <TableCell onClick={() => openCampaign(campaign)}>{campaign.name}</TableCell>
            <TableCell>{moment(campaign.start_date).local().format(FULLDATE_FORMAT_SLASHES)}</TableCell>
            <TableCell>{moment(campaign.end_date).local().format(FULLDATE_FORMAT_SLASHES)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>

    <Pagination
      items={timelines}
      onChangePage={props.getTimelines}
    />
  </>
);

CampaignTab.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  openCampaign: PropTypes.func.isRequired,
  timelines: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
    })),
  }).isRequired,
  getTimelines: PropTypes.func.isRequired,
};

const styles = () => ({
  table: {
    '& th, td': {
      textAlign: 'center',
    },
    '& th:first-child, td:first-child': {
      textAlign: 'left',
    },
  },
});

export default compose(
  connect(
    state => ({
      timelines: state.timelines,
    }),
    { getTimelines },
  ),
  withStyles(styles),
)(CampaignTab);
